<template>
  <div class="score_Affirmation">
      <Header title="成绩认定" type='0' route="/homeIndex"></Header>
      <div class="score_content"> 
        <h4 style="color: #212F6E;font-size: 16px;">已修课程</h4>
        <NOdata v-if="this.courseList.length == 0 && isLoad" title="暂无数据~"></NOdata>
        <div class="course_list" v-else>
          <a v-for="(item,index) in courseList" :key="index" @click="canSelect(item.CANCHECK)">
            <div style="width:85%;">
              <h4 v-if="schoolCode == '12763' && item.ZCJ < 60 " style="color: red;">{{item.COURSENAME}}</h4>
              <h4 v-else>{{item.COURSENAME}}</h4>
              <p style="font-size: 12px;margin-bottom:2px;line-height:17px;">课程代码：{{item.COURSECODE}}</p>
              <div style="font-size: 12px;line-height:17px;" v-if="schoolCode != '12763'">
                <span>学分：<small>{{item.CREDIT}}</small></span>
                <span>属性：<small>{{item.COURSEATTRIBUTE}}</small></span>
              </div>
              <div style="font-size: 12px;line-height:17px;" v-else>
                <table>
                  <tr>
                    <td>
                      <span>学分：<small>{{item.CREDIT}}</small></span>
                    </td>
                    <td>
                      <span>属性：<small>{{item.COURSEATTRIBUTE}}</small></span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>成绩：<small>{{item.ZCJ}}</small></span>
                    </td>
                    <td>
                      <span>学期：<small>{{item.XQMC}}</small></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <el-checkbox v-model="item.checked" v-if="item.CANCHECK == 1"></el-checkbox>
          </a>
        </div>
      </div>
      <div class="score_foot">
        <button class="next_btn" v-if="schoolCode == '12763'" @click="thKcsxxztx()">替换属性和性质、课程体系</button>
        <button class="score_btn" @click="Check()">已申请认定</button>
        <button class="next_btn" @click="goDetail()">下一步</button>
      </div>
      <van-popup v-model="show" class="popup">
        <span @click="ggtzclose" class="close" >
          <van-icon  name="cross" size="18" color="#C8C9CC" />
        </span>
          <van-form @submit="onSubmit">
            <van-field
              readonly
              clickable
              name="课程属性"
              :value="kcsxText"
              input-align="right"
              is-link
              error-message-align="right"
              label="课程属性"
              placeholder="请选择"
              @click="showkcsxPicker = true"
            />

            <van-field
              readonly
              clickable
              name="课程性质"
              :value="kcxzText"
              input-align="right"
              is-link
              error-message-align="right"
              label="课程性质"
              placeholder="请选择"
              @click="showkcxzPicker = true"
            />

            <van-field
              readonly
              clickable
              name="课程体系"
              :value="kctxText"
              input-align="right"
              is-link
              error-message-align="right"
              label="课程体系"
              placeholder="请选择"
              @click="showkctxPicker = true"
            />

            <div class="qz-button-group">
              <template >
                <button class="thsxxztxBtn" native-type="submit">替换属性和性质、课程体系</button>
              </template>
            </div>
          </van-form>
    </van-popup>
    <van-popup v-model="showkcsxPicker" round position="bottom" v-if="schoolCode == '12763'">
      <van-picker
        show-toolbar
        :columns="preData[0].list"
        @cancel="showkcsxPicker = false"
        @confirm="onkcsxConfirm"
      />
    </van-popup>
    <van-popup v-model="showkcxzPicker" round position="bottom" v-if="schoolCode == '12763'">
      <van-picker
        show-toolbar
        :columns="preData[1].list"
        @cancel="showkcxzPicker = false"
        @confirm="onkcxzConfirm"
      />
    </van-popup>
    <van-popup v-model="showkctxPicker" round position="bottom" v-if="schoolCode == '12763'">
      <van-picker
        show-toolbar
        :columns="preData[2].list"
        @cancel="showkctxPicker = false"
        @confirm="onkctxConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from '../../../utils/axios'
  export default {
    data(){
      return {
        courseList:[],
        valueList:[],
        isLoad:false,
        schoolCode : sessionStorage.getItem("schoolCode"),
        show:false,
        showkcsxPicker:false,
        kcsxText:'',
        kcsxValue:'',
        showkcxzPicker:false,
        kcxzText:'',
        kcxzValue:'',
        showkctxPicker:false,
        kctxText:'',
        kctxValue:'',
        preData:[{ title: "", list: [] }],
        ThvalueList:[],
      }
    },
    created(){
      this.getList()
    },
    methods:{
      async getList(){
        const res = await Api.achievementRecognition()
        if(res.code == "0"){
          this.$toast(res.Msg);
          this.$router.replace('/student/score_apply');
        }
        if(this.schoolCode == '12763'){
          this.preData = res.initData;
          console.log(this.preData)
        }
        this.courseList = res.data;
        this.isLoad = true;
      },
      Check(){
        this.$router.push('/student/score_apply')
      },
      canSelect(val){
        if(val == '0'){
          this.$toast.fail('当前课程不可选')
        }
      },
      goDetail(){
        for(let i = 0;i < this.courseList.length;i++){
          if(this.courseList[i].checked){
            this.valueList +=  this.courseList[i].CJ0708ID + ',';
          }
        }
        if(this.valueList.length == 0){
          this.$toast.fail('请选择要替换的课程')
        }else{
          this.valueList = this.valueList.substring(0,this.valueList.length-1)
          this.$router.push({
            path:'/student/score_replace',
            query:{
              'data':this.valueList,
            }
          })
        }
      },
      thKcsxxztx(){
        this.kcsxText = '';
        this.kcxzText = '';
        this.kctxText='';

        this.kcsxValue = '';
        this.kcxzValue = '';
        this.kctxValue='';
        this.show = true;
      },
      async thSave(){
        this.ThvalueList=[];
        var kclb=this.kcsxValue;
        var kcxz=this.kcxzValue;
        var jxp01kctxid = this.kctxValue;
        
        for(let i = 0;i < this.courseList.length;i++){
          if(this.courseList[i].checked){
            this.ThvalueList +=  this.courseList[i].CJ0708ID + ','+this.courseList[i].KCID +'~';
          }
        }
        if(this.ThvalueList.length == 0){
          this.$toast.fail('至少选择一门课程！')
        }else{
          this.ThvalueList = this.ThvalueList.substring(0,this.ThvalueList.length-1)
          if(kclb=='' && kcxz=='' && jxp01kctxid != ''){
            const params = {
              jxp01kctxid:jxp01kctxid,
              cj0708ids:this.ThvalueList
            }
            const res = await Api.yxkcTh(params)
            this.$toast(res.Msg)
            setTimeout(() => {
                this.show = false;
                this.getList();
            }, 1500);
          }
          else if(kclb==''){
            this.$toast.fail('请选择课程属性！')
          }else{
            if(kcxz==''){
              this.$toast.fail('请选择课程性质！')
            }else{
              const params = {
                kcxz:kcxz,
                kclb:kclb,
                cj0708ids:this.ThvalueList
              }
              const res = await Api.yxkcTh(params)
              this.$toast(res.Msg)
              setTimeout(() => {
                  this.show = false;
                  this.getList();
              }, 1500);
            }
          }
        }
      },
      ggtzclose(){
        this.show = false;
      },
      onkcsxConfirm(data){
        this.kcsxText = data.text;
        this.kcsxValue = data.id;
        this.showkcsxPicker = false;
      },
      onkcxzConfirm(data){
        this.kcxzText = data.text;
        this.kcxzValue = data.id;
        this.showkcxzPicker = false;
      },
      onkctxConfirm(data){
        this.kctxText = data.text;
        this.kctxValue = data.id;
        this.showkctxPicker = false;
      },
      onSubmit(){
        this.thSave()
      },
    }
  }
</script>

<style lang="less" scoped>
  .score_foot .next_btn{background-color: @attendance-background-color-1;color: @attendance-color-3;height: 44px;width:calc(~"50% - 10px");border-radius: 4px;}
  .score_Affirmation .score_content{padding: 15px;}
  .score_Affirmation  .course_list{margin-bottom: 75px;}
  .score_Affirmation  .course_list a{border-radius: 5px; width: 100%;display: flex;justify-content: space-between;align-items: center;background: @attendance-background-color-10;padding:10px 20px;
    box-sizing: border-box;color:@attendance-color-2 ;margin-top: 20px;}
  .score_Affirmation  .course_list a h4{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;color: @attendance-color-1;margin-bottom: 4px;font-size: 16px;line-height: 22px;}
  .score_Affirmation  .course_list a small{color: red;margin-right: 23px;font-size: 12px;}
  .score_Affirmation  .course_list a .icon_right{height: 15px;width: 15px; background: url(../../../../static/img/arrow.png) center center no-repeat;background-size: contain;}
  .score_Affirmation .score_foot{width: 100%;display: flex;justify-content: space-between;position: fixed;bottom: 0px;z-index: 9;background-color: @attendance-color-3;padding: 0 19px;box-sizing: border-box;}
  .score_Affirmation .score_foot .score_btn{width:calc(~"50% - 10px");height:44px;background:rgba(236,237,253,1);border-radius:4px;font-size:16px;font-family:PingFangSC;
    font-weight:600;color:@attendance-background-color-1;}
  .score_Affirmation .score_foot button{margin:20px 5px;}
  .score_Affirmation .el-checkbox__inner{width: 18px;height: 18px;border-radius: 50%;border: 2px solid @attendance-border-color-4}
  .score_Affirmation .el-checkbox__inner::after{left: 5px;top: 2px;border-width: 2px;}
  .score_Affirmation .el-checkbox__input.is-checked .el-checkbox__inner{background: @attendance-background-color-1;border-color:@attendance-background-color-1;}
  .popup {
    width: 311px;
    height: 230px;
    background: #ffffff;
    border-radius: 8px;
    padding: 20px;

    .close {
      z-index: 99999;
      position: absolute;
      top: 4px;
      right: 5px;
      width: 24px;
      height: 24px;
      padding: 3px;
      box-sizing: border-box;
    }
    .qz-button-group {
      .thsxxztxBtn{
        width: 100%;
        height: 44px;
        background-color: #7469F8;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 600;
        color: #ffffff;
        position: absolute;
        left: 35px;
        bottom: 5px;
        width: 80%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/student/Score/score_Affirmation.vue